var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40777 38.7664L19.7337 20.4437C19.9472 20.2302 19.9472 19.8859 19.7337 19.6723L1.40777 1.35159C1.06338 1.00725 0.476562 1.25156 0.476562 1.73631V38.3797C0.476562 38.8664 1.06338 39.1088 1.40777 38.7645V38.7664Z",
    fill: "#8850FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5039 20.4456L38.8298 38.7683C39.1742 39.1126 39.761 38.8683 39.761 38.3835V1.73819C39.761 1.25151 39.1742 1.00913 38.8298 1.35346L20.5039 19.6761C20.2904 19.8897 20.2904 20.234 20.5039 20.4475V20.4456Z",
    fill: "#8850FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/Img3.33c8a77a4c86669f46b7d1eeb82f3460.svg";
export { ForwardRef as ReactComponent };